import type { FC } from 'react'
import styled from '@emotion/styled'

import type { Option } from '@segment/matcha/components/Menu/useMenu'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import type { Filter } from '@segment/api/types/common'

import FilterSelect from './FilterSelect'

const toOptionProps = (filter: Filter) => {
  const { title, id } = filter
  return {
    value: id,
    text: title,
  }
}

interface FiltersProps {
  filters: [
    string,
    {
      title: string
      items: Filter[]
    }
  ][]
  onFilterChange?: (filterId: string, selectedOptions: Option[]) => void
  disabled?: boolean
}

const Filters: FC<FiltersProps> = ({ onFilterChange = () => null, filters }) => {
  return (
    <StyledSectionBase variant="noCopy">
      <Section.Contents>
        <StyledColumnTrack gap="small" columns={1} overrides={{ lg: filters?.length }}>
          {filters?.map(([key, filter]) => (
            <FilterSelect
              key={key}
              id={key}
              placeholder={filter.title}
              options={filter.items.map(toOptionProps)}
              onSelect={(selectedOptions) => onFilterChange(key, selectedOptions)}
            />
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;

  ${Section.Wrapper} {
    justify-content: unset;
    padding-top: 0;
    padding-bottom: 0;
    row-gap: 24px;
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 520px;
  row-gap: 8px;
  margin: 0 auto;
  margin-bottom: 8px;

  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    padding: 0 80px;
  }
`

export default Filters
